/**
 * 引导图相关
 */
import store from '@/store';
import Dayjs from 'dayjs';
import $config from '@/config/index';

const commonOptions = {
  params: {
    Bucket: $config.ossBucket,
  },
  endpoint: 'ossnewhope.oak.net.cn', // your endpoint
  s3ForcePathStyle: true,
  sslEnabled: true,
  apiVersion: '2006-03-01',
};

const uploadOptions = {
  partSize: 1024 * 1024 * 10,
  queueSize: 1,
};

const baseUrl = 'cooperation/';

export default {
  async created() {
    // 利用该方式可将aws-sdk独立打包，异步引入
    await import (
      /* webpackChunkName: "aws-s3-sdk" */
      'aws-sdk/clients/s3'
    ).then(({ default: S3} ) => {
      this.S3  = S3; // 不在data里申明，提升性能
    });

  },
  destroyed() {
    this.S3 = null;
  },
  methods: {
    // 获取文件名
    _getFileName(name) {
      return name.substring(0, name.lastIndexOf('.'));
    },
    // 获取 .后缀名
    _getExtension(name) {
      return name.substring(name.lastIndexOf('.'));
    },
    /**
     * 统一上传方法
     * @param {Object} file elementui-upload组件读取的file对象
     * @param {Fuction} progress 进度回调函数
     * @param {*} complete 完成回调函数
     */
    async _uploadCommon(
      file,
      progress = () => {},
      options = {
        hashFileName: false,
        isSecret: false
      }
    ) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const ossConfig = await store.dispatch('getAwsOssToken');
        const { awsAccessKey, awsSecretKey, sessionToken } = ossConfig;
        const s3 = new this.S3({
          ...commonOptions,
          credentials: {
            accessKeyId: awsAccessKey,
            secretAccessKey: awsSecretKey,
            sessionToken: sessionToken
          }
        });
        const name = this._getFileName(file.name);
        const type = this._getExtension(file.name);
        const { hashFileName = false, isSecret = false } = options;
        const day = Dayjs().format('YYYYMMDD');
        const fileName = hashFileName
          ? `${baseUrl}${new Date().getTime()}/${
              Math.random() * 100000
            }-${day}${type}`
          : `${baseUrl}${new Date().getTime()}/${name}-${day}${type}`;

        const params = {
          Key: fileName,
          Body: file,
          ACL: isSecret ? "private" : "public-read",
        };

        const upload = s3
          .upload(params, uploadOptions, (err, data) => {
            console.log('文件上传：', err, data);
            reject(err);
          })
          .on('httpUploadProgress', (e) => {
            let percent = parseInt(e.loaded, 10) / parseInt(e.total, 10);
            percent = Number((percent * 100).toFixed(2));
            progress(percent);
          });

        const sendUpload = () => {
          upload.send((err, data) => {
            if (err) {
              console.log('文件上传：', err);
              reject(err);
            } else {
              const url = `https://${data.Location.split('://')[1]}`;
              resolve({ url });
            }
          });
        };

        sendUpload();
      });
    },
    ossUpload(file, progress = () => {}) {
      return this._uploadCommon(file, progress);
    },
    // 将文件名替换为时间戳
    ossUploadNoFileName(file, progress = () => {}) {
      return this._uploadCommon(file, progress, {
        hashFileName: true,
      });
    },
    // 上传私密文件
    ossUploadSecret(file, progress = () => {}) {
      return this._uploadCommon(file, progress, {
        isSecret: true
      })
    }
  },
};
